import './App.css';
import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

// pages
import PrivateRouter from "./components/PrivateRouter/PrivateRouter"
import PublicRouter from './components/PublicRouter/PublicRouter';
import NotFoundRedirect from './components/NotFoundRedirect/NotFoundRedirect';
import Login from './components/Login/Login';
import Dashboard from './components/Dashboard/Dashboard';
import Layout from './components/Layout/Layout';
import UserManagement from './components/UserManagement/userlist';
import UserDetail from './components/UserManagement/userDetails';
import ForgotPassword from './components/ForgotPassword/ForgotPassword';
import ResetPassword from './components/ResetPassword/ResetPassword';
import RolesAndPermissions from './components/RolesAndPermissions/RolesAndPermissions';
import ManageRolesAndPermissions from './components/RolesAndPermissions/ManageRolesAndPermissions';
import CategoryManagement from './components/CategoryManagement/CategoryManagement';
import DropdownManagement from './components/DropdownManagement/DropdownManagement';
import CallLogs from './components/CallLogs/CallLogs';
import CallStatus from './components/CallStatus/CallStatus';
import ViewUsers from './components/RolesAndPermissions/ViewUsers';
import SettingsLayout from './components/Settings/Layout';
import EmailSettings from './components/Settings/EmailSettings';
import CallSettings from './components/Settings/CallSettings';
import SiteSettings from './components/Settings/SiteSettings';
import Knowledgebase from './components/Knowledgebase/Knowledgebase';
import KBCategory from './components/Knowledgebase/KBCategory';
import ScheduleShift from './components/ScheduleShift/ScheduleShift';
import QaSectionView from './components/QaManagement/QaSectionView';
import QaQuestionView from './components/QaManagement/QaQuestionView';
import CampaignList from './components/Campaign/CampaignList';
import AgentAssignment from './components/Campaign/AgentAssignment';
import ReportingHierarchy from './components/Campaign/ReportingHierarchy';
import QueueList from './components/Queue/QueueList';
import { UserAccessProvider } from './components/Context/UserAccessContext';
import Profile from './components/Profile/profile'

function App() {
  return (
    <React.Fragment>
      <BrowserRouter>
        <UserAccessProvider>

          <ToastContainer style={{ zIndex: 99999 }} />

          <Routes>
            
            <Route path='/'
              element={
                <PublicRouter>
                  <Login />
                </PublicRouter>
              }
            />
            <Route path='/forgotPassword' element={<ForgotPassword />} />
            <Route path="/resetPassword/:token" element={<ResetPassword />} />


            <Route element={<Layout />}>

              <Route path='/dashboard' element={<PrivateRouter menuId={1} />}>
                <Route index element={<Dashboard />} />
              </Route>

              <Route path='/user/list' element={<PrivateRouter menuId={2} />}>
                <Route index element={<UserManagement />} />
              </Route>

              <Route path='/user/detail' element={<PrivateRouter menuId={2} />}>
                <Route index element={<UserDetail />} />
              </Route>

              <Route path='/viewUsers' element={<PrivateRouter menuId={2} />}>
                <Route index element={<ViewUsers />} />
              </Route>

              <Route path='/roles' element={<PrivateRouter menuId={3} />}>
                <Route index element={<RolesAndPermissions />} />
              </Route>

              <Route path='/manageRole' element={<PrivateRouter menuId={3} />}>
                <Route index element={<ManageRolesAndPermissions />} />
              </Route>

              <Route path='/callLogs' element={<PrivateRouter menuId={4} />}>
                <Route index element={<CallLogs />} />
              </Route>

              <Route path='/knowledgeBase' element={<PrivateRouter menuId={5} />}>
                <Route index element={<KBCategory />} />
              </Route>

              <Route path='/manageKnowledgebase' element={<PrivateRouter menuId={5} />}>
                <Route index element={<Knowledgebase />} />
              </Route>

              <Route path='/createKnowledgebase' element={<PrivateRouter menuId={5} />}>
                <Route index element={<Knowledgebase />} />
              </Route>

              <Route path='/qaSection' element={<PrivateRouter menuId={6} />}>
                <Route index element={<QaSectionView />} />
              </Route>
              <Route path='/qaQuestion' element={<PrivateRouter menuId={6} />}>
                <Route index element={<QaQuestionView />} />
              </Route>

              <Route path='/category' element={<PrivateRouter menuId={7} />}>
                <Route index element={<CategoryManagement />} />
              </Route>

              <Route path='/dropdown' element={<PrivateRouter menuId={7} />}>
                <Route index element={<DropdownManagement />} />
              </Route>

              <Route path='/callStatus' element={<PrivateRouter menuId={8} />}>
                <Route index element={<CallStatus />} />
              </Route>

              <Route path='/shiftManagement' element={<PrivateRouter menuId={9} />}>
                <Route index element={<ScheduleShift />} />
              </Route>

              <Route path='/queue' element={<PrivateRouter menuId={10} />}>
                <Route index element={< QueueList />} />
              </Route>

              <Route path="/campaign" element={< PrivateRouter menuId={11} />}>
                <Route path="campaign-list" element={<CampaignList />} />
                <Route path="agent-assignment" element={<AgentAssignment />} />
                <Route path="reporting-hierarchy" element={<ReportingHierarchy />} />
              </Route>

              <Route path="/settings" element={<PrivateRouter menuId={12} />}            >
                <Route element={<SettingsLayout />}>
                  <Route path="general" element={<SiteSettings />} />
                  <Route path="SMTP" element={<EmailSettings />} />
                  <Route path="call" element={<CallSettings />} />
                </Route>
              </Route>
              <Route path='/profile' element={<PrivateRouter />} >
                <Route index element={< Profile />} />
              </Route>
            </Route>

            <Route path="*" element={<NotFoundRedirect />} />
          </Routes>
        </UserAccessProvider>
      </BrowserRouter>
    </React.Fragment>
  );
}

export default App;
